function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
//Limitless imports
import { useKnowledgeLibraryContext } from "../../hooks/knowledge/KnowledgeLibraryContext";
import SearchInput from "@limitless/modern/inputs/search-input/SearchInput";
const KnowledgeSearchInput = ({
  variant,
  ...rest
}) => {
  const {
    selectedLibrary,
    libraryResults,
    searchLibrary,
    updateSearchTerm,
    loadCategoryArticles,
    clearSearchTerm
  } = useKnowledgeLibraryContext();
  const {
    searchTerm
  } = libraryResults;
  const handleClearSearch = () => {
    clearSearchTerm();
    loadCategoryArticles(selectedLibrary, selectedLibrary.knowledgeCategory);
  };
  const handleSubmitSearchTerm = value => {
    searchLibrary(value);
  };
  return /*#__PURE__*/React.createElement(SearchInput, _extends({
    placeholder: "Search for articles",
    id: "knowledgeBaseSearchInput",
    value: searchTerm || "",
    onSubmit: handleSubmitSearchTerm,
    onChange: value => updateSearchTerm(value),
    clearSearch: handleClearSearch,
    variant: variant
  }, rest));
};
export default KnowledgeSearchInput;
KnowledgeSearchInput.propTypes = {
  variant: PropTypes.string
};